import * as actionTypes from './actionType';

export const getRecommendationsForRange = (id, startDate, endDate) => ({
    type: actionTypes.GET_RECOMMENDATIONS_FOR_RANGE,
    id,
    startDate,
    endDate,
    isLoading: true,
});
export const getOTAInsightsByRange = (id, startDate, endDate) => ({
    type: actionTypes.GET_OTA_INSIGHTS_BY_RANGE,
    id,
    startDate,
    endDate,
});
export const getOTAInsightsExport = (id, startDate, endDate) => ({
    type: actionTypes.GET_OTA_INSIGHTS_EXPORT,
    id,
    startDate,
    endDate,
});
export const getEventsForRange = (id, startDate, endDate) => ({
    type: actionTypes.GET_EVENTS_BY_RANGE,
    id,
    startDate,
    endDate,
    isLoading: true,
});
